angular
  .module("AccountingBoxApp")
  .controller("BankRulesCtrl", function(
    $scope,
    $rootScope,
    $location,
    $filter,
    $stateParams,
    $state,
    $window,
    // ngTableParams,
    BankRule,
    LoopBackAuth,
  ) {
    var vm = this;
    $scope.order = {
      by: "bankAccountNumber",
      reverse: false,
      filter: ""
    };

    vm.editBankRule = function(bankRule) {
      $scope.bankRule = bankRule;
      $scope.$broadcast("editBankRule");

      $("#bankRuleModal").modal("show");
    };
    vm.newBankRule = function() {
      $scope.$broadcast("newBankRule");
      $("#bankRuleModal").modal("show");
    };

    $scope.$on("closeBankRule", function(e, bankRule) {
      $("#bankRuleModal").modal("hide");
    });

    $scope.$on("bankRuleSaved", function(e, bankRule) {
      vm.loadBankRules();
      setTimeout(function() {
        vm.loadBankRules();
      }, 10000);
    });

    $scope.$on("removeBankRuleConfirmation", function(e, bankRule) {
      $scope.removeBankRule = bankRule;
      $("#bankRuleModal").modal("hide");
      $("#removeModal").appendTo("#app-content");
      $("#removeModal").modal("show");
    });

    vm.removeBankRule = function(bankRule) {
      $("#removeModal").modal("hide");
      BankRule.deleteById({
        id: bankRule.id
      }).$promise.then(function() {
        vm.loadBankRules();
      });
    };

    vm.loadBankRules = function() {
      vm.loading = true;
      BankRule.find(function(bankRules) {
        vm.bankRules = bankRules;
        vm.loading = false;
      });
    };

    vm.loadBankRules();
  });
